import React, { useState, useEffect } from "react";
import axios from "axios";
import CommonHeader from "../Common Header/CommonHeader";
import "./gallery.css";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

const Gallery = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [galleryData, setGalleryData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0); // Track index

  const getSchoolYear = () => {
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();

    if (currentMonth >= 8) {
      return currentYear;
    } else {
      return currentYear - 1;
    }
  };

  const [selectedYear, setSelectedYear] = useState(getSchoolYear());

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    gettingData();
  }, []);

  useEffect(() => {
    filterData();
  }, [selectedYear, selectedEvent, galleryData]);

  const gettingData = async () => {
    try {
      const response = await axios.get("/schoolGallery.php");
      if (response?.status === 200) {
        setGalleryData(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const filterData = () => {
    if (galleryData.length > 0) {
      let filtered = galleryData.filter((item) => {
        return (
          item.year === selectedYear &&
          (selectedEvent === "" || item.title === selectedEvent)
        );
      });
      setFilteredData(filtered);
    }
  };

  const getUniqueValues = (key) => {
    return [...new Set(galleryData.map((item) => item[key]))];
  };

  const years = galleryData ? getUniqueValues("year") : [];
  const events = galleryData ? getUniqueValues("title") : [];

  const handleImageClick = (image, index) => {
    setSelectedImage(image);
    setSelectedImageIndex(index);
    document.body.style.overflow = "hidden";
    setIsOpen(true);
  };

  const closePreview = () => {
    setSelectedImage(null);
    document.body.style.overflow = "auto";
    setIsOpen(false);
  };

  const handleNext = () => {
    const currentEvent = filteredData.find((event) =>
      event.images.includes(selectedImage)
    );
    if (!currentEvent) return;

    const currentIndex = currentEvent.images.indexOf(selectedImage);
    if (currentIndex < currentEvent.images.length - 1) {
      const nextImage = currentEvent.images[currentIndex + 1];
      setSelectedImage(nextImage);
      setSelectedImageIndex(currentIndex + 1);
    }
  };

  const handlePrevious = () => {
    const currentEvent = filteredData.find((event) =>
      event.images.includes(selectedImage)
    );
    if (!currentEvent) return;

    const currentIndex = currentEvent.images.indexOf(selectedImage);
    if (currentIndex > 0) {
      const prevImage = currentEvent.images[currentIndex - 1];
      setSelectedImage(prevImage);
      setSelectedImageIndex(currentIndex - 1);
    }
  };

  return (
    <>
      <CommonHeader heading={"Our Gallery"} />
      <div className="container gallerySection">
        <div className="row">
          <div className="col-md-12 text-center mb-3">
            <div className="row" style={{ marginTop: "2rem" }}>
              <div className="col-sm-6">
                <select
                  className="form-control"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(parseInt(e.target.value))}
                >
                  <option value="">All Years</option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-sm-6">
                <select
                  className="form-control"
                  value={selectedEvent}
                  onChange={(e) => setSelectedEvent(e.target.value)}
                >
                  <option value="">All Events</option>
                  {events.map((event) => (
                    <option key={event} value={event}>
                      {event}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {filteredData.map((eventItem) => (
          <div key={eventItem.id} className="row mb-4">
            <div className="col-md-12 maincontent">
              <h3 className="text-center upercaseTitle">{eventItem.title}</h3>
            </div>
            <div className="row">
              <div className="col-md-12 topmargin">
                <ResponsiveMasonry
                  columnsCountBreakPoints={{ 350: 2, 750: 3, 900: 5 }}
                  gutterBreakpoints={{ 350: "12px", 750: "16px", 900: "24px" }}
                >
                  <Masonry>
                    {eventItem.images.map((image, index) => (
                      <div
                        key={index}
                        className="portfolio-item"
                        onClick={() => handleImageClick(image, index)}
                      >
                        <img
                          src={axios.defaults.baseURL + "/Images/" + image}
                          style={{
                            objectFit: "cover",
                            border: "2px solid grey",
                            cursor: "pointer",
                          }}
                          alt={eventItem.title}
                        />
                      </div>
                    ))}
                  </Masonry>
                </ResponsiveMasonry>
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div
          className={`image-preview-modal ${isOpen ? "open" : ""}`}
          onClick={closePreview}
          role="dialog"
          aria-labelledby="imagePreviewTitle"
          aria-hidden={!isOpen}
        >
          <div
            className="image-preview-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="preview-nav preview-prev"
              onClick={handlePrevious}
            >
              &lt;
            </button>
            <img
              src={`${axios.defaults.baseURL}/Images/${selectedImage}`}
              alt="Preview"
              className="full-screen-image"
            />
            <button className="preview-nav preview-next" onClick={handleNext}>
              &gt;
            </button>
            <button
              className="close-preview"
              onClick={closePreview}
              aria-label="Close preview"
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;
